module.exports = __webpack_public_path__ + "static/img/08032A_1_R_20201018_fit.fd37676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08032A_1_R_20201018_fit.png
// module id = Jcnv
// module chunks = 0